module.exports = __webpack_public_path__ + "static/faq-40b5b67df42d4ac2fe4df5d859b8a9f7.jpg";